import http from "../http-common";

const repoPath = '/Schools';

const getAll = () => {
  return http.get(`${repoPath}?page_size=5000`);
};

const get = (id) => {
  return http.get(`${repoPath}/${id}`);
};

const create = (data) => {
  return http.post(repoPath, data);
};

const update = (id, data) => {
  return http.put(`${repoPath}/${id}`, data);
};

const remove = (id) => {
  return http.delete(`${repoPath}/${id}`);
};

const CityService = {
  getAll,
  get,
  create,
  update,
  remove,
};

export default CityService;
